/** Canonical values stored in candidates_calls.status */
export const CALL_STATUSES = [
  'No response',
  'Scheduled interview',
  'Open to meet',
  'Blacklist',
  'Answered',
];

const STATUS_LABEL_KEYS = {
  'no response': 'ai.calls.statusNoResponse',
  'scheduled interview': 'ai.calls.statusScheduledInterview',
  'open to meet': 'ai.calls.statusOpenToMeet',
  blacklist: 'ai.calls.statusBlacklist',
  answered: 'ai.calls.statusAnswered',
};

const STATUS_CLASSNAMES = {
  'no response': 'bg-amber-50 text-amber-800 border-amber-200',
  'scheduled interview': 'bg-blue-100 text-blue-800 border-blue-200',
  'open to meet': 'bg-green-100 text-green-800 border-green-200',
  blacklist: 'bg-red-50 text-red-700 border-red-200',
  answered: 'bg-teal-100 text-teal-800 border-teal-200',
};

export const normalizeCallStatus = (status) => String(status ?? '').trim();

export const getCallStatusKey = (status) => normalizeCallStatus(status).toLowerCase();

export const isKnownCallStatus = (status) => (
  Object.prototype.hasOwnProperty.call(STATUS_LABEL_KEYS, getCallStatusKey(status))
);

export const getCallStatusLabelKey = (status) => (
  STATUS_LABEL_KEYS[getCallStatusKey(status)] || null
);

export const getCallStatusClassName = (status) => (
  STATUS_CLASSNAMES[getCallStatusKey(status)] || 'bg-gray-100 text-gray-800 border-gray-200'
);

export const getCallStatusFilterOptions = (t) => [
  { value: 'all', label: t('ai.calls.statusAll') },
  ...CALL_STATUSES.map((status) => ({
    value: status,
    label: t(getCallStatusLabelKey(status)),
  })),
];

export const matchesCallStatusFilter = (status, filter) => {
  if (!filter || filter === 'all') return true;
  return getCallStatusKey(status) === getCallStatusKey(filter);
};
